import { action, observable, makeObservable, reaction, IReactionDisposer } from 'mobx';
import {IStickyHandler} from './sticky-handler.interface';
import {DomEventSubscription} from '../../../utils/event-listener-registration';
import {IServiceFactory} from "../../services/service-factory.interface";

export class StickyHandler implements IStickyHandler {
    private _onScrollSubscription: DomEventSubscription;
    private _onHeaderHeightReactionDisposer: IReactionDisposer
    private _scrollTopMinValue: number = -1;

    constructor(private services: IServiceFactory) {
        makeObservable(this);
        this._onHeaderHeightReactionDisposer = reaction(() => this.services.header.headerHeight, (headerHeight) => {
            this._scrollTopMinValue = headerHeight;
        }, {
           fireImmediately: true
        });
        this._onScrollSubscription = this.services.window.subscribeTo.scroll(this.onWindowScroll);
    }

    @observable.ref
    private _isSticky: boolean = false;
    get isSticky(): boolean {
        return this._isSticky;
    }

    @action.bound
    private _setIsSticky(value: boolean): void {
        this._isSticky = value;
    }

    private onWindowScroll = () => {
        if (this._scrollTopMinValue < 0) {
            this._setIsSticky(false);
        } else {
            this._setIsSticky(this.services.window.scrollY > this._scrollTopMinValue);
        }
    };

    dispose() {
        if (this._onScrollSubscription) {
            this._onScrollSubscription.dispose();
        }
        this._onHeaderHeightReactionDisposer();
    }

}
